







import {Vue, Component} from 'vue-property-decorator';
import {drawerNavigation, multiNil, nil} from '@/common';
import {intersection} from 'lodash';
import UserRoleMixin from '@/mixins/UserRoleMixin.vue';
import {Mixins} from 'vue-property-decorator';

@Component({
    components: {
    },
})
export default class BottomNavigation extends Mixins(UserRoleMixin) {
    public get navigationItems() {
        return drawerNavigation.filter((x) => !!x.icon).filter((x) => this.verifyUserRole(x.roles));
    }
    public verifyUserRole(roles: string[]) {
        if (nil(roles)) {
            return true;
        }
        if (multiNil(this, 'user.roles', true)) {
            return false;
        }
        return intersection(roles, this.user.roles).length > 0;
    }
}
